/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organization_Settings_DescriptionInputs */



/**
* | output |
* | --- |
* | "Manage your organization's profile, branding, and settings" |
*
* @param {Organization_Settings_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const organization_settings_description = /** @type {((inputs?: Organization_Settings_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organization_Settings_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwalte das Profil, das Branding und die Einstellungen deiner Organisation")
	return /** @type {LocalizedString} */ ("Manage your organization's profile, branding, and settings")
});